import { getEnvVariableByKey } from './tenantUtils';
import { FORM_SUBMITTED_KEY } from './sessionStorageKeys';

const FALLBACK_SESSION_TTL_MINUTES = 30;

// Reads REACT_APP_SESSION_TTL_MINUTES, falls back to 30 when unset or invalid
function getSessionTtlMinutes(): number {
  const configuredMinutes = Number(
    getEnvVariableByKey('REACT_APP_SESSION_TTL_MINUTES')
  );
  const isValid = Number.isFinite(configuredMinutes) && configuredMinutes > 0;
  return isValid ? configuredMinutes : FALLBACK_SESSION_TTL_MINUTES;
}

export const DEFAULT_SESSION_TTL_MS = getSessionTtlMinutes() * 60 * 1000;

export function isSessionDataExpired(
  savedAt: number,
  ttlMs: number = DEFAULT_SESSION_TTL_MS
): boolean {
  return Date.now() - savedAt > ttlMs;
}

export function saveSessionValue(key: string, value: string): void {
  try {
    sessionStorage.setItem(key, value);
  } catch {}
}

export function loadSessionValue(key: string): string | null {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function saveSessionData(key: string, data: Record<string, any>): void {
  try {
    sessionStorage.setItem(key, JSON.stringify(data));
  } catch {}
}

export function loadSessionData<T = Record<string, any>>(
  key: string
): T | null {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function setSessionFlagTrue(key: string): void {
  try {
    sessionStorage.setItem(key, 'true');
  } catch {}
}

export function isSessionFlagTrue(key: string): boolean {
  try {
    return sessionStorage.getItem(key) === 'true';
  } catch {
    return false;
  }
}

export function removeSessionFlag(key: string): void {
  try {
    sessionStorage.removeItem(key);
  } catch {}
}

// Clears current project's session-scoped keys
export function clearProjectSessionData(project: string | undefined): void {
  if (!project) return;
  try {
    const suffix = `:${project}`;
    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.endsWith(suffix)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
    sessionStorage.removeItem(FORM_SUBMITTED_KEY);
  } catch {}
}
